if (!customElements.get('variant-picker')) {
	class VariantPicker extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.productId       = this.dataset.productId || null;
			this.productForm     = this.closest('product-form');
			this.submitForm      = this.productForm.querySelector('.submit-form');
			this.optionSelectors = this.querySelectorAll('.option-selector');
			this.qtyTableEl      = this.querySelector('.qty-table');
			this.quantityInput   = this.submitForm?.querySelector('quantity-input');
			this.quantity        = this.quantityInput?.querySelector('.quantity');

			try{
				const templateVariants = this.querySelector(`template#template-variants-${this.productId}`);

				if(templateVariants){
					this.variantData = JSON.parse(templateVariants.content?.textContent);
				}
			}catch(error){
				console.error(error);
			}
			if(this.variantData) {
				window.theme.productVariants[this.productId] = this.variantData;
			}

			this.qtyTabls        = window.getQtyTable(this.variantData) || null;
			this.selectedOptions = this.getSelectedOptions();
			this.variant         = this.getSelectedVariant();

	    this.updateAvailability();
	    this.updateBtnAddToCart();
	    this.handleQtyChange();

	    // this.handleVariantChange(this);
			this.addEventListener('change',this.handleVariantChange.bind(this));
			this.quantity?.addEventListener('change', this.handleQtyChange.bind(this));
			this.processSearchParams();

	  }

	  /**
	   * Handles 'change' events on the variant picker
	   */
	  handleVariantChange(e){
			this.selectedOptions = this.getSelectedOptions();
			this.variant         = this.getSelectedVariant();
			this.noSelect        = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      this.updateUrl(e);
      this.updateBtnAddToCart();
      this.updateVariantId();
      this.updateAvailability();
      this.updatePrice();
      this.updateBackorder();
      this.updateSku();
      this.updateBarcode();
      this.updatePickupAvailability();
      this.handleQtyChange();

      this.dispatchEvent(new CustomEvent('variant:change', { 
      	bubbles: true, 
      	detail: {
      		variant:this.variant,
      		variantData:this.variantData,
      		qtyTabls:this.qtyTabls
      	}
      }));
	  }
	  /**
		 * Update Qty tables
		 */
		handleQtyChange(){
			if(!this.qtyTabls) return;
			if(!this.quantity) return;

			const qtyTabls = this.qtyTabls?.table;
      const curQty = qtyTabls.find(r => this.quantity.value >= r.min && this.quantity.value <= r.max);

      const targetVariant = this.querySelector(`[value="${curQty.label}"]`);
      if(targetVariant){
      	if (targetVariant.tagName === 'OPTION') {
      		targetVariant.selected = true;
      	} else {
      		targetVariant.click();
      	}
        this.selectedOptions = this.getSelectedOptions();
        this.variant         = this.getSelectedVariant();
      }

      if(!this.qtyTableEl) return;

			const qtyTd = this.qtyTableEl.querySelector(`[data-qty-variant="${this.variant.id}"]`);
			if(!qtyTd) return;

			this.qtyTableEl.querySelectorAll('td').forEach(td => td.classList.remove('table-danger'));
			qtyTd.classList.add('table-danger');
		}
	  /**
	   * Get the selected values from a list of variant options
	   */
	  getSelectedOptions(){
	  	let selectedOptions = [];
	  	this.optionSelectors.forEach(el => {
	  		let selected = el.querySelector('input:checked')?.value;
	  		if(el?.dataset?.selectorType === 'dropdown') selected = el.querySelector('.form-select')?.value;

	  		selectedOptions.push(selected ? selected : null);
	  		if (selected) {
	  			const selectLabel = el.querySelector('.option-selector-label');
	  			if(selectLabel) selectLabel.textContent = selected;
	  		}
	  	});
	  	return selectedOptions;
	  }
	  /**
	   * Get selected variant data
	   */
	  getSelectedVariant(){
	  	return this.variantData.find(
        (v) => v.options.every((val, index) => val === this.selectedOptions[index])
      );
	  }

	  /**
		 * Updates the url with the selected variant id.
		 */
		updateUrl(e) {
		  if (!e || e.type !== 'change' || this.dataset.updateUrl === 'false') return;
		  const url = this.variant ? `${this.dataset.url}?variant=${this.variant.id}` : this.dataset.url;

		  window.history.replaceState({ }, '', url);
		}

		/**
		 * Updates the availability status in option selectors.
		 */
		updateAvailability() {
		  if (this.dataset.availability === 'off') return;

		  const currOption = this.variant ? this.variant.options : this.selectedOptions;

		  this.optionSelectors.forEach((ele, index) => {
		    const selectorType = ele.dataset.selectorType;
		    let optionsList, available = '';
		    
		    if (selectorType === 'dropdown') {
		      const formSelect = ele.querySelector('.form-select');
		      optionsList = formSelect?.querySelectorAll('option') || [];
		      available = formSelect?.dataset.available || '';
		    } else {
		    	optionsList = ele.querySelectorAll('.variant-label');
		    }
		    
		    optionsList.forEach(el => {
		      let optionValue = selectorType === 'dropdown' ? el.getAttribute('value') : el.querySelector('input')?.value;
		      
		      if (selectorType === 'dropdown') {
		        if (optionValue === currOption[index]) {
		          el.setAttribute('selected', 'selected');
		        } else {
		          el.removeAttribute('selected');
		        }
		      }

		      const isAvailable = this.variantData.some((v) => {
		        const matchesPrevious = Array.from({length: index}, (_, i) => 
		          v.options[i] === currOption[i] || currOption[i] === null
		        ).every(Boolean);
		        
		        return v.options[index] === optionValue && matchesPrevious && v.available;
		      });

		      if (selectorType === 'dropdown') {
		        el.setAttribute('data-available', isAvailable ? '' : available);
		      } else {
		        el.classList.toggle('disabled', !isAvailable);
		      }
		    });
		  });
		}
		/**
		 * Update the "Add to Cart" button label and status.
		 */
		updateBtnAddToCart(){
			if(!this.submitForm) return;
			if(this.selectedOptions.includes(null)) return;

			this.atcBtn = this.atcBtn || this.submitForm.querySelector('[name="add"]');
			if(!this.atcBtn) return;

			const variantAvailable = this.variant && this.variant.available;
			const unavailable = this.variant ? (this.atcBtn.dataset.noStock || 'Out of Stock') : (this.atcBtn.dataset.noVariant || 'Unavailable');
		  const addToCartText = this.atcBtn.dataset.addToCart || 'Add to Cart';

			this.atcBtn.disabled = !variantAvailable;
		  this.atcBtn.textContent = variantAvailable ? addToCartText : unavailable;
		}
		/**
		 * Updates the value of the hidden [name="id"]
		 */
		updateVariantId(){
			if(!this.productForm) return;
			this.productForm.querySelectorAll('[name="id"]')?.forEach(el => {
				el.value = this.variant ? this.variant.id : '';
				el.dispatchEvent(new Event('change',{bubbles:true}));
			});
		}
		/**
     * Updates the price
     */
		updatePrice() {
			this.priceEl = this.priceEl || this.productForm.querySelector('.product-price .price');
			if(!this.priceEl) return;

			let variant = this.variant;
			if(this.noSelect){
				variant = this.variantData.reduce((lowest, current) => {
				  return current.price < lowest.price ? current : lowest;
				}, this.variantData[0]);
			}
			if (variant) {
				const priceCurr = this.priceEl.querySelector('.price-current');
				const priceWas  = this.priceEl.querySelector('.price-was');
				const priceUnit = this.priceEl.querySelector('.unit-price');

		    if (priceCurr && this.variant?.format_data?.price) {
		      priceCurr.textContent = this.variant?.format_data?.price;
		    }
		    
		    if (priceWas && this.variant?.format_data?.compareAtPrice) {
		      priceWas.textContent = this.variant?.format_data?.compareAtPrice || '';
		    }

		    if (variant.unit_price_measurement) {
		      const value = variant.unit_price_measurement.reference_value;
		      const unit = variant.unit_price_measurement.reference_unit;
		      
		      if (priceUnit) {
		        const unitPricePrice = priceUnit.querySelector('.unit-price-price');
		        const unitPriceUnit = priceUnit.querySelector('.unit-price-unit');
		        
		        if (unitPricePrice && this.variant?.format_data?.unitPrice) {
		          unitPricePrice.textContent = this.variant?.format_data?.unitPrice;
		        }
		        if (unitPriceUnit) {
		          unitPriceUnit.textContent = value === 1 ? unit : `${value} ${unit}`;
		        }
		        priceUnit.hidden = false;
		      }
		    } else if (priceUnit) {
		      priceUnit.hidden = true;
		    }

		    this.priceEl.classList.toggle('price-on-sale', variant.compare_at_price > variant.price);
		    this.priceEl.classList.toggle('price-sold-out', !variant.available && !this.noSelect);

		    this.productForm.querySelector('media-gallery').classList.toggle('card-product-soldout', !variant.available && !this.noSelect);
			}

			this.priceEl.hidden = !this.variant && !this.noSelect;

			const priceForm = this.priceEl.querySelector('.price-from');
			if(priceForm) priceForm.hidden = !this.noSelect;
		}
		/**
		 * Updates the backorder text and visibility.
		 */
		updateBackorder(){
			this.backorder = this.backorder || this.productForm.querySelector('.backorder');
			if(!this.backorder) return;

			let hideBackorder = true;
			if(this.variant && this.variant.available){
				const inventory = this.variant?.format_data?.inventory;

				if(this.variant.inventory_management && inventory === 'none'){
					const backOrderProduct = this.backorder.querySelector('.backorder-product');
					const backOrderProductTitle = this.productForm.querySelector('.product-title');
					const variantTitle = this.variant.title.includes('Default') ? '' : ` - ${this.variant.title}`;

					backOrderProduct.textContent = `${backOrderProductTitle.textContent}${variantTitle}`;
					hideBackorder = false;
				}
			}
			this.backorder.hidden = hideBackorder;
		}
		/**
		 * Updates the SKU.
		 */
		updateSku(){
			this.sku = this.sku || this.productForm.querySelector('.product-sku');
			if(!this.sku) return;

			this.skuValue = this.sku.querySelector('.product-sku-value');
			if(!this.skuValue) return;

			const skuAvailable = this.variant && this.variant.sku;
      this.skuValue.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.hidden = !skuAvailable;
		}
		/**
		 * Updates the Barcode.
		 */
		updateBarcode(){
			this.barcode = this.barcode || this.productForm.querySelector('.product-barcode');
			if(!this.barcode) return;

			this.barcodeValue = this.barcodeValue || this.productForm.querySelector('.product-barcode-value');
			if(!this.barcodeValue) return;

			const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodeValue.textContent = barcodeAvailable ? this.variant.barcode : '';
      this.barcode.hidden = !barcodeAvailable;
		}
		/**
		 * Updates the pick up availability.
		 */
		updatePickupAvailability(){
			this.pickupAvailability = this.pickupAvailability || this.productForm.querySelector('pickup-availability');
			if (!this.pickupAvailability) return;

			customElements.whenDefined('pickup-availability').then(() => {
				if (this.variant && this.variant.available) {
	        this.pickupAvailability.getAvailability(this.variant.id);
	      } else {
	        this.pickupAvailability.removeAttribute('available');
	        this.pickupAvailability.innerHTML = '';
	      }
			}).catch(error => {
				console.error(error);
			});
		}
		/**
		 * process search parameters.
		 */
		processSearchParams(searchParamsObject = null) {
		  let searchParams;
		  if (searchParamsObject instanceof URLSearchParams) {
		    searchParams = searchParamsObject;
		  } else {
		    searchParams = new URLSearchParams(window.location.search);
		  }
		  
		  searchParams.forEach((value, key) => {
		    let matchingOptionSelector = null;
		    
		    this.optionSelectors.forEach((el) => {
		      if (el.dataset.option === key) {
		        matchingOptionSelector = el;
		      }
		    });
		    if (!matchingOptionSelector) return;
		    
		    if (matchingOptionSelector.dataset.selectorType === 'dropdown') {
		      const matchingSelect = matchingOptionSelector.querySelector(`select[name="${key}"]`);
		      if (matchingSelect) {
		        matchingSelect.value = value;
		        matchingSelect.dispatchEvent(new Event('change', { bubbles: true }));
		      }
		    } else {
		      const matchingInput = matchingOptionSelector.querySelector(`input[value="${value}"]`);
		      if (matchingInput) {
		        const matchingOptionLabel = matchingOptionSelector.querySelector('.option-selector-label');
		        if (matchingOptionLabel) {
		          matchingOptionLabel.textContent = value;
		        }
		        matchingInput.checked = true;
		        matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
		      }
		    }
		  });
		}
	}

	customElements.define('variant-picker', VariantPicker);
}